import {MDCTextField} from '@material/textfield/index';
import {MDCRipple} from '@material/ripple';


class Comments {
    
    constructor(commentForm) {
        this.commentForm = commentForm || null;
        this.isValid;
        this.nameField = null;
        this.emailField = null;
        this.commentField = null;

        this. isLoggedIn = document.body.classList.contains('logged-in');

        if (this.commentForm != null) {
            commentForm.addEventListener('submit', this.onSubmit);

            const domComment = this.commentForm.querySelector('.comment-text');
            domComment.addEventListener('focusout', this.onFieldBlur);
            this.commentField = new MDCTextField(domComment);

            new MDCRipple(this.commentForm.querySelector('.comment-submit'));

            if (!this.isLoggedIn) {
                const domName = this.commentForm.querySelector('.comment-author');
                const domEmail = this.commentForm.querySelector('.comment-email');
    
                domName.addEventListener('focusout', this.onFieldBlur);
                domEmail.addEventListener('focusout', this.onFieldBlur);

                this.nameField = new MDCTextField(domName);
                this.emailField = new MDCTextField(domEmail);        
            }
        }
    };

    onSubmit = event => {
        const isValid = this.isValid();

        if (!isValid) {
            event.preventDefault();
        }
        this.toggleErrorMessage(!isValid);
        this.commentForm.classList.toggle('submitted', true);
    }

    onFieldBlur = event => {
        if (this.commentForm.classList.contains('submitted')) {
            const isValid = this.isValid();
            this.toggleErrorMessage(!isValid);
        }
    }

    isValid() {
        return this.commentField.valid &&
        (this.isLoggedIn || (
            this.nameField.valid &&
            this.emailField.valid
        ));
    }

    toggleErrorMessage(showError) {
        showError = (showError === true);
        this.commentForm.classList.toggle('invalid', showError);
    }

}

export {Comments};